import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import * as XLSX from "xlsx";

dayjs.extend(customParseFormat);

export function cellToString(value: unknown): string {
  if (value == null || value === "") return "";
  if (typeof value === "number" && Number.isFinite(value)) {
    return Number.isInteger(value) ? String(value) : String(value);
  }
  return String(value).trim();
}

export function normalizeHeader(value: unknown): string {
  return cellToString(value)
    .replace(/^\uFEFF/, "")
    .toLowerCase()
    .replace(/\.+$/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

/** Parse money cells; empty / "-" → 0; invalid → null. */
export function parseAmount(value: unknown): number | null {
  const raw = cellToString(value).replace(/,/g, "").replace(/\s+/g, "");
  if (!raw || raw === "-") return 0;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

const TXN_DATE_FORMATS = [
  "DD-MM-YYYY",
  "D-M-YYYY",
  "DD/MM/YYYY",
  "D/M/YYYY",
  "DD/MM/YY",
  "D/M/YY",
  "DD-MM-YY",
  "D-M-YY",
  "YYYY-MM-DD",
] as const;

export function parseTxnDate(value: unknown): Date | null {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return dayjs(value).startOf("day").toDate();
  }
  const raw = cellToString(value);
  if (!raw) return null;
  for (const fmt of TXN_DATE_FORMATS) {
    const parsed = dayjs(raw, fmt, true);
    if (parsed.isValid()) return parsed.startOf("day").toDate();
  }
  return null;
}

export function findHeaderIndex(cells: string[], synonyms: string[]): number {
  return cells.findIndex((c) => synonyms.includes(c));
}

export function sheetToAoa(sheet: XLSX.WorkSheet, opts: { raw?: boolean } = {}): unknown[][] {
  return XLSX.utils.sheet_to_json<unknown[]>(sheet, {
    header: 1,
    defval: "",
    raw: opts.raw ?? false,
  });
}

export const BANK_XLSX_READ_OPTS: XLSX.ParsingOptions = {
  cellDates: true,
  dateNF: "dd-mm-yyyy",
};

export function readBankWorkbook(
  buf: ArrayBuffer | Uint8Array,
  opts: XLSX.ParsingOptions = {}
): XLSX.WorkBook {
  return XLSX.read(buf, { type: "array", ...BANK_XLSX_READ_OPTS, ...opts });
}

export function readBankWorkbookFromText(
  text: string,
  opts: XLSX.ParsingOptions = {}
): XLSX.WorkBook {
  return XLSX.read(text, { type: "string", ...BANK_XLSX_READ_OPTS, ...opts });
}
